module.exports = __webpack_public_path__ + "svg/diamonds.svg?d42778ae76703de87caba858b1396bb8";